import { divide } from './math';

const DEFAULT_DECIMAL_PLACES = 2;

export const percentageToDecimal = (decimalAmount: number, decimalPlaces: number = DEFAULT_DECIMAL_PLACES): number =>
  divide(decimalAmount, 100, decimalPlaces);
